<section id="cart-open-address-modal" class="cart-address" *ngIf="showInRoute && isLogin && !isSaG" (click)="openAddressModal()">
  <div class="address-popup" *ngIf="showAddressPopUp && !address">
    <p class="text">Necesitas una dirección de entrega</p>
    <span id="cart-toggle-address-popup" class="close-button material-icons" (click)="toggleAddressPopUp()">x</span>
    <div class="arrow-message-green"></div>
  </div>
  <p class="placeholder" *ngIf="!address">Selecciona dirección de entrega</p>
  <p class="placeholder text-truncate" *ngIf="address">{{ address.address }}</p>
  <app-icons [type]="'arrow-simple'" [color]="isMobile ? '#418fde' : '#ffffff'" [custom]="'down'"></app-icons>
</section>
